<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- This is the tree node template for leaf nodes  -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [ngClass]="{'crossed': node.crossed}">
        <button mat-icon-button></button>
        {{node.name}}
    </mat-tree-node>

    <!-- This is the tree node template for expandable nodes  -->
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [ngClass]="{'crossed': node.crossed}">
        <button mat-icon-button (click)="toggleNode(node)">
            <mat-icon>
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        {{node.name}}
    </mat-tree-node>
</mat-tree>